import mqtt from 'mqtt'

let mqttClient = null

// Initialize MQTT Client
export const initializeMqtt = (brokerUrl, options, isEnableLoggingMqtt) => {
  return new Promise((resolve, reject) => {
    // Cleanup existing connection before creating new one
    if (mqttClient) {
      clogMqtt(
        'Cleaning up existing MQTT connection before re-initializing',
        null,
        isEnableLoggingMqtt
      )
      try {
        mqttClient.removeAllListeners()
        mqttClient.end(true)
        mqttClient = null
      } catch (error) {
        clogMqtt(
          `Error cleaning up MQTT client: ${error}`,
          null,
          isEnableLoggingMqtt
        )
      }
    }

    mqttClient = mqtt.connect(brokerUrl, options)

    mqttClient.on('connect', () => {
      clogMqtt('MQTT connected', isEnableLoggingMqtt)
      resolve(mqttClient) // Resolve the promise when connected
    })

    mqttClient.on('error', (err) => {
      console.log('MQTT connection error:', err)
      clogMqtt(`MQTT connection error: ${err}`, isEnableLoggingMqtt)
      resolve() // Reject the promise if there's an error
    })

    mqttClient.on('close', () => {
      resolve()
    })

    mqttClient.on('offline', (offline) => {
      resolve()
    })

    mqttClient.on('reconnect', (reconnect) => {
      resolve()
    })
  })
}

// Access MQTT Client
export const getMqttClient = () => {
  if (!mqttClient) {
    throw new Error('MQTT is not initialized. Call initializeMqtt first.')
  }
  return mqttClient
}

export const reconnectMqttClient = () => {
  if (mqttClient) {
    mqttClient.reconnect()
  }
}

/**
 * Disconnect MQTT Client
 * NOTE: Intentionally does NOT unsubscribe from topics before disconnecting.
 * The broker will handle topic cleanup when the connection closes.
 * This prevents unnecessary network calls and ensures clean session termination.
 */
export const disconnectMqttClient = () => {
  if (mqttClient) {
    mqttClient.end()
    mqttClient = null
    console.log('MQTT disconnected')
  }
}

export const clogMqtt = (message, data = null, isEnableLogingMqtt) => {
  if (isEnableLogingMqtt) {
    if (data !== null) {
      console.log(message, data)
    } else {
      console.log(message)
    }
  }
}
